import React from "react";
import { FiDownload, FiFilePlus, FiFileText, FiClock } from "react-icons/fi";
import { deviceDummyData } from "../../../Data/DeviceData";

const FORMAT_COLORS = {
  PDF:   { color: "#ef4444", bg: "#fee2e2" },
  Excel: { color: "#10b981", bg: "#d1fae5" },
  CSV:   { color: "#3b82f6", bg: "#dbeafe" },
};

const REPORT_TYPES = [
  { name: "Device Health Summary",        desc: "Health scores, status and battery overview for all devices",  formats: ["PDF", "Excel"] },
  { name: "Connectivity Diagnostics",     desc: "RSSI, SNR, packet loss and signal trend for all devices",     formats: ["PDF", "Excel", "CSV"] },
  { name: "Alert & Event Export",         desc: "Full alert log and event trail with timestamps",               formats: ["CSV", "PDF"] },
  { name: "Firmware Audit",               desc: "Current firmware versions, update status and compliance",      formats: ["PDF"] },
  { name: "Battery Status Report",        desc: "Battery levels, projected replacement schedule",               formats: ["PDF", "CSV"] },
  { name: "Topology Map Export",          desc: "Gateway hierarchy, connected devices and network structure",   formats: ["PDF"] },
];

const DvcReportsPanel = () => {
  return (
    <div className="dvc-reports-panel">
      {/* Generate Reports */}
      <div className="dvc-section-title">Generate Reports</div>
      <div className="dvc-report-grid">
        {REPORT_TYPES.map(r => (
          <div key={r.name} className="dvc-report-card">
            <div className="dvc-report-icon"><FiFileText size={20} color="#667eea" /></div>
            <div className="dvc-report-name">{r.name}</div>
            <div className="dvc-report-desc">{r.desc}</div>
            <div className="dvc-report-actions">
              {r.formats.map(f => {
                const fc = FORMAT_COLORS[f] || { color: "#6b7280", bg: "#f3f4f6" };
                return (
                  <button key={f} className="dvc-ctrl-btn" style={{ background: fc.bg, color: fc.color, border: `1px solid ${fc.color}44`, gap: 5, fontSize: 12 }}>
                    <FiDownload size={12} /> {f}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Scheduled Reports */}
      <div className="dvc-section-title" style={{ marginTop: 24 }}>Scheduled Reports</div>
      <div className="dvc-sched-table">
        <div className="dvc-srt-header">
          <span>Report Name</span><span>Schedule</span><span>Last Generated</span><span>Size</span><span>Action</span>
        </div>
        {deviceDummyData.reports.map(r => {
          const f = r.format;
          const fc = FORMAT_COLORS[f] || { color: "#6b7280", bg: "#f3f4f6" };
          return (
            <div key={r.id} className="dvc-srt-row">
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ padding: "2px 7px", borderRadius: 10, background: fc.bg, color: fc.color, fontSize: 11, fontWeight: 700 }}>{f}</span>
                {r.name}
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 5, color: "#6b7280", fontSize: 12 }}>
                <FiClock size={12} /> {r.schedule}
              </span>
              <span style={{ color: "#374151", fontSize: 12 }}>{r.lastGenerated}</span>
              <span style={{ color: "#9ca3af", fontSize: 12 }}>{r.size}</span>
              <button className="dvc-ctrl-btn dvc-ctrl-blue" style={{ gap: 5, fontSize: 12 }}>
                <FiDownload size={12} /> Download
              </button>
            </div>
          );
        })}
      </div>

      <div className="dvc-report-note">
        <FiFilePlus size={13} color="#667eea" />
        Reports are generated automatically on schedule. Manual generation uses current live device data snapshot. All reports include device metadata, health scores and connectivity details.
      </div>
    </div>
  );
};

export default DvcReportsPanel;
